import {
  getIdToken,
  reload,
  sendEmailVerification,
  type User,
} from "firebase/auth";
import { friendlyFirebaseError } from "./friendlyFirebaseError";

export const EMAIL_VERIFICATION_COOLDOWN_MS = 60_000;

export function verificationCooldownSeconds(availableAt: number, now = Date.now()) {
  return Math.max(0, Math.ceil((availableAt - now) / 1000));
}

export function emailVerificationErrorMessage(error: unknown) {
  const code = String((error as { code?: unknown } | null)?.code ?? "").toLowerCase();
  if (code === "auth/user-disabled") return "Ce compte a été désactivé.";
  if (code === "auth/user-token-expired" || code === "auth/requires-recent-login") {
    return "Ta session a expiré. Déconnecte-toi puis reconnecte-toi.";
  }
  return friendlyFirebaseError(error, "Impossible d’envoyer l’email. Réessaie dans un instant.");
}

export async function resendVerificationEmail(user: User) {
  await sendEmailVerification(user);
}

export async function refreshEmailVerification(user: User) {
  await reload(user);
  if (user.emailVerified) await getIdToken(user, true);
  return user.emailVerified;
}
